export default "__VITE_ASSET__kfktJw9___"